import CustomizableDatagrid from './CustomizableDatagrid';

export default CustomizableDatagrid;
